import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { FamilyTreeSetService } from './api/familyTreeSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class FamilyTreeApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<FamilyTreeApiModule> {
        return {
            ngModule: FamilyTreeApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: FamilyTreeApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('FamilyTreeApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
